import { render } from "./Services.vue?vue&type=template&id=617250c5"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/Services.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "617250c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('617250c5', __exports__)) {
    api.reload('617250c5', __exports__)
  }
  
  module.hot.accept("./Services.vue?vue&type=template&id=617250c5", () => {
    api.rerender('617250c5', render)
  })

}


export default __exports__